/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Scope_Detail5Inputs */

const en_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform decision, cross-platform vs native against your real requirements.`)
};

const ar_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قرار المنصة: متعدد المنصات أم أصلي، وفق متطلباتك الفعلية.`)
};

const bn_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্ল্যাটফর্ম সিদ্ধান্ত, আপনার আসল প্রয়োজন অনুযায়ী ক্রস-প্ল্যাটফর্ম বনাম নেটিভ।`)
};

const de_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformentscheidung, plattformübergreifend oder nativ im Vergleich zu Ihren tatsächlichen Anforderungen.`)
};

const es_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decisión de plataforma, multiplataforma vs nativa frente a sus requisitos reales.`)
};

const fr_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décision de plateforme, multiplateforme ou native par rapport à vos besoins réels.`)
};

const pt_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decisão de plataforma, multiplataforma vs nativo de acordo com seus requisitos reais.`)
};

const zh_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台决策：跨平台还是原生，看您的真实需求。`)
};

const tr_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform kararı: gerçek ihtiyaçlarınıza göre cross-platform mu native mi.`)
};

const ru_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор платформы: кроссплатформа или натив под ваши реальные требования.`)
};

const pl_svc_mobile_app_development_scope_detail5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decyzja dotycząca platformy, platforma wieloplatformowa czy natywna w porównaniu z rzeczywistymi wymaganiami.`)
};

/**
* | output |
* | --- |
* | "Platform decision, cross-platform vs native against your real requirements." |
*
* @param {Svc_Mobile_App_Development_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_scope_detail5 = /** @type {((inputs?: Svc_Mobile_App_Development_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "de") return de_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "es") return es_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_scope_detail5(inputs)
	return en_svc_mobile_app_development_scope_detail5(inputs)
});
export { svc_mobile_app_development_scope_detail5 as "svc_mobile-app-development_SCOPE_detail" }